import React, { useEffect, useState, ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/output.scss';
import SubTitle from '../component/sub-title';
import Color from '@/tool/color';

import Tab from '../component/tab';
import TimeTab from '../component/time-tab';
import moOutput, { changeTab, changeTimeTab } from './store/output';
import OutputChart from './component/output-chart';
import moEffectPdf from '../store';
import defalut from '@static/image/default-bg.png';
import Empty from '@/component/empty';
import MainTitle from '../component/main-title';
import URI from 'urijs';
import moCapital from './store/capital-analysis';
import Sub from '../component/sub';
import moMenu from '@/page/effect/store/menu';


interface IProps { }
interface IState { }

const OutputTop10 = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { outputList } = moOutput;
  const uri = new URI(window.location.href);
  const path: any = uri.query(true);
  const result: any = decodeURIComponent(path.check);
  const data = JSON.parse(result);


  const emen: any = {
    营业收入: 'revenue',
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    人均薪酬成本: 'cost_per_staff',
    薪酬成本: 'cost',
    净利润: 'profit',
  };

  const getTopList = (val: string) => {
    const active = emen[val];
    let cList: any = [];
    let eList: any = [];
    let jList: any = [];
    if (!isEmpty(outputList)) {
      cList = outputList[active]?.current_top10;
      eList = outputList[active]?.exit_list.map((item: any) => {
        let items: any = {};
        items = { ...item, icons: outputList.company_logo_dict[item.company_name] };
        return items;
      });
      jList = outputList[active]?.join_list.map((item: any) => {
        let items: any = {};
        items = { ...item, icons: outputList.company_logo_dict[item.company_name] };
        return items;
      });
    }
    return { cList, eList, jList };
  };

  const getDanwei = (val: string) => {
    let type = 'big';
    if (val === '营业收入' || val === '薪酬成本' || val === '净利润') {
      type = 'big';
    } else {
      type = 'samll';
    }
    return type;
  };

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect06" className="output-top10-warp-pdf human-common-pdf">
      <MainTitle
        title='人力投入与产出TOP10'
        subtitle={moMenu.industryName}
        year={data.tabList.ft}
        bgcolor={Color.primaryColor(0.1)}
        color={Color.primary} />
      {data.tabList?.f1 && <section>
        <Sub title='营业收入' />
        <p>单位:{getDanwei('营业收入') === 'big' ? '亿元' : '元'}</p>
        <section className="chart-demo">
          {!isEmpty(getTopList('营业收入')?.cList) ? <section className="chart">
            <OutputChart activeTab="营业收入" />
          </section> : <Empty />}
        </section>
        {(!isEmpty(getTopList('营业收入')?.jList) || !isEmpty(getTopList('营业收入')?.eList)) && <section className="output-detail-top">
          {!isEmpty(getTopList('营业收入')?.jList) && <p>本期新进TOP10：</p>}
          {
            getTopList('营业收入')?.jList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />

          {!isEmpty(getTopList('营业收入')?.eList) && <p className='out'>本期退出TOP10：</p>}
          {
            getTopList('营业收入')?.eList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />
        </section>}
      </section>}

      {data.tabList?.f2 && <section>
        <Sub title='人均营业收入' />
        <p>单位:{getDanwei('人均营业收入') === 'big' ? '亿元' : '元'}</p>
        <section className="chart-demo">
          {!isEmpty(getTopList('人均营业收入')?.cList) ? <section className="chart">
            <OutputChart activeTab="人均营业收入" />
          </section> : <Empty />}
        </section>
        {(!isEmpty(getTopList('人均营业收入')?.jList) || !isEmpty(getTopList('人均营业收入')?.eList)) && <section className="output-detail-top">
          {!isEmpty(getTopList('人均营业收入')?.jList) && <p>本期新进TOP10：</p>}
          {
            getTopList('人均营业收入')?.jList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />

          {!isEmpty(getTopList('人均营业收入')?.eList) && <p className='out'>本期退出TOP10：</p>}
          {
            getTopList('人均营业收入')?.eList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />
        </section>}
      </section>}

      {data.tabList?.f3 && <section>
        <Sub title='人均净利润' />
        <p>单位:{getDanwei('人均净利润') === 'big' ? '亿元' : '元'}</p>
        <section className="chart-demo">
          {!isEmpty(getTopList('人均净利润')?.cList) ? <section className="chart">
            <OutputChart activeTab="人均净利润" />
          </section> : <Empty />}
        </section>
        {(!isEmpty(getTopList('人均净利润')?.jList) || !isEmpty(getTopList('人均净利润')?.eList)) && <section className="output-detail-top">
          {!isEmpty(getTopList('人均净利润')?.jList) && <p>本期新进TOP10：</p>}
          {
            getTopList('人均净利润')?.jList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />

          {!isEmpty(getTopList('人均净利润')?.eList) && <p className='out'>本期退出TOP10：</p>}
          {
            getTopList('人均净利润')?.eList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />
        </section>}
      </section>}

      {data.tabList?.f4 && <section>
        <Sub title='人均薪酬成本' />
        <p>单位:{getDanwei('人均薪酬成本') === 'big' ? '亿元' : '元'}</p>
        <section className="chart-demo">
          {!isEmpty(getTopList('人均薪酬成本')?.cList) ? <section className="chart">
            <OutputChart activeTab="人均薪酬成本" />
          </section> : <Empty />}
        </section>
        {(!isEmpty(getTopList('人均薪酬成本')?.jList) || !isEmpty(getTopList('人均薪酬成本')?.eList)) && <section className="output-detail-top">
          {!isEmpty(getTopList('人均薪酬成本')?.jList) && <p>本期新进TOP10：</p>}
          {
            getTopList('人均薪酬成本')?.jList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />

          {!isEmpty(getTopList('人均薪酬成本')?.eList) && <p className='out'>本期退出TOP10：</p>}
          {
            getTopList('人均薪酬成本')?.eList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />
        </section>}
      </section>}

      {data.tabList?.f5 && <section>
        <Sub title='薪酬成本' />
        <p>单位:{getDanwei('薪酬成本') === 'big' ? '亿元' : '元'}</p>
        <section className="chart-demo">
          {!isEmpty(getTopList('薪酬成本')?.cList) ? <section className="chart">
            <OutputChart activeTab="薪酬成本" />
          </section> : <Empty />}
        </section>
        {(!isEmpty(getTopList('薪酬成本')?.jList) || !isEmpty(getTopList('薪酬成本')?.eList)) && <section className="output-detail-top">
          {!isEmpty(getTopList('薪酬成本')?.jList) && <p>本期新进TOP10：</p>}
          {
            getTopList('薪酬成本')?.jList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />

          {!isEmpty(getTopList('薪酬成本')?.eList) && <p className='out'>本期退出TOP10：</p>}
          {
            getTopList('薪酬成本')?.eList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />
        </section>}
      </section>}

      {data.tabList?.f6 && <section>
        <Sub title='净利润' />
        <p>单位:{getDanwei('净利润') === 'big' ? '亿元' : '元'}</p>
        <section className="chart-demo">
          {!isEmpty(getTopList('净利润')?.cList) ? <section className="chart">
            <OutputChart activeTab="净利润" />
          </section> : <Empty />}
        </section>
        {(!isEmpty(getTopList('净利润')?.jList) || !isEmpty(getTopList('净利润')?.eList)) && <section className="output-detail-top">
          {!isEmpty(getTopList('净利润')?.jList) && <p>本期新进TOP10：</p>}
          {
            getTopList('净利润')?.jList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />

          {!isEmpty(getTopList('净利润')?.eList) && <p className='out'>本期退出TOP10：</p>}
          {
            getTopList('净利润')?.eList.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <i style={{ backgroundImage: `url(${res.icons || defalut})` }} />
                <span>{res.company_name}</span>
              </section>;
            })
          }
          <b />
        </section>}
      </section>}

    </section>
  );
};

export default observer(OutputTop10);
